<template>
    <div> 
        <table class="table table-sm">
        <thead>
        <tr>
            <th>SEDE DI PROVENIENZA</th>
            <th >DATA</th>
            <th >ARTICOLO</th>
            <th >COLORE</th>
            <th >MISURA</th>
            <th >BRAND</th>
            <th >CATEGORIA</th>
            <th >REPARTO</th>
            <th >STAGIONE</th>
            <th >BARCODE</th>
        </tr>
        </thead>
        <tbody>
            <tr v-for="(item,index) in booking" :key="index">
                <td style="color:blue">{{ item.description1 }}</td>                    
                <td >{{ item.date }}</td>                    
                <td class="text-nowrap">{{ item.description2.sku }}</td>                    
                <td class="text-nowrap">{{ item.description2.color }}</td>                    
                <td class="text-nowrap">{{ item.description2.size }}</td>                    
                <td class="text-nowrap">{{ item.description2.brand }}</td>                    
                <td class="text-nowrap">{{ item.description2.category }}</td>                    
                <td >{{ item.description2.department }}</td>                    
                <td class="text-nowrap">{{ item.description2.season }}</td>                    
                <td>{{ item.description2.barcode }}</td>                    
            </tr>                    
        </tbody>
    </table>                        
</div>
    
</template>
 <script>
  
   export default {
    props:['booking'],
    data() {
      return {
      }
    },
  }

</script>
<style scoped>

  
 td{
  
    color       : black;
  
 } 

 

  </style>